import React, { useEffect } from 'react'

export default function PostcodeCheck() {
  useEffect(() => {
    // Check if the hash has been set
    const isReloaded = window.location.hash === '#postcode'

    if (!isReloaded) {
      // If not reloaded, set the hash and force reload
      window.location.hash = 'postcode'
      window.location.reload()
    }
  }, [])

  return <div id="offerte-aanvragen-container"></div>
}

// import React, { useEffect, useState, useRef } from 'react'
// import styled from 'styled-components'
// import { motion } from 'framer-motion'
// import Geocode from 'react-geocode'
// import { Formik, Form, Field } from 'formik'
// import Cursor from './icons/cursor.inline.svg'
// import Arrow from './icons/arrow.inline.svg'
// import API from './helpers/API'
// import storage from './helpers/storage'
// import homeInfo from './graphql/homeInfo'
// import Loading from './elements/Loading'
// import { useSendOptionsStore } from './Order/Order'

// const StyledSearch = styled(Form)`
//   background-color: ${(props) => props.theme.color.face.secondary};
//   min-height: 150px;
//   display: flex;
//   align-items: center;
//   overflow: hidden;
//   position: relative;

//   @media (min-width: 992px) {
//     border-radius: 75px;
//   }

//   @media (max-width: 991px) {
//     border-radius: 15px;
//   }
// `

// export const InputWrapper = styled.div`
//   position: relative;
//   display: flex;
//   align-items: center;
// `

// export const Error = styled.div`
//   position: absolute;
//   font-size: ${(props) => props.theme.font.size.s};
//   color: ${(props) => props.theme.color.text.negative};

//   @media (min-width: 992px) {
//     bottom: 5px;
//     left: 17px;
//   }

//   @media (max-width: 991px) {
//     bottom: 7px;
//     left: 25px;
//   }
// `

// export const Input = styled(Field)`
//   font-weight: ${(props) => props.theme.font.weight.m};
//   color: ${(props) => props.theme.color.text.main};
//   border-bottom: 1px solid ${(props) => props.theme.color.text.main};
//   border-top: none;
//   border-left: none;
//   border-right: none;
//   outline: none;
//   background-color: transparent;
//   width: 100%;

//   &::placeholder {
//     font-weight: ${(props) => props.theme.font.weight.s};
//     color: ${(props) => props.theme.color.text.main};
//   }

//   -webkit-appearance: none;
//   appearance: none;

//   @media (min-width: 992px) {
//     font-size: ${(props) => props.theme.font.size.m};
//     height: 35px;

//     ${(props) =>
//       props.haserror &&
//       `
//       padding-bottom: 12px !important;
//     `};
//   }

//   @media (max-width: 991px) {
//     background-color: ${(props) => props.theme.color.face.light};
//     font-size: ${(props) => props.theme.font.size.m};
//     height: 45px;
//     border: none;
//     padding: 0 10px;
//     border-radius: 5px;

//     ${(props) =>
//       props.haserror &&
//       `
//       padding-bottom: 15px !important;
//     `};
//   }
// `

// export const Label = styled.label`
//   opacity: 0;
//   position: absolute;
//   left: -999px;
//   top: -999px;
// `

// export const Submit = styled.button`
//   font-weight: ${(props) => props.theme.font.weight.l};
//   background: ${(props) => props.theme.color.gradient.main};
//   color: ${(props) => props.theme.color.text.light};
//   border-radius: 25px;

//   &:disabled {
//     opacity: 0.5;
//     cursor: initial;
//   }
// `

// const CurrentLocation = styled.div`
//   font-size: ${(props) => props.theme.font.size.sm};
//   font-weight: ${(props) => props.theme.font.weight.l};
//   color: ${(props) => props.theme.color.text.secondary};
//   padding: 0;
//   position: absolute;
//   bottom: -20px;
//   right: 15px;

//   &:hover {
//     text-decoration: underline;
//   }
// `

// const CurrentLocationButton = styled.button`
//   background-color: ${(props) => props.theme.color.face.contrast};
//   border-radius: 50%;
//   min-width: 20px;
//   min-height: 20px;
//   max-width: 20px;
//   max-height: 20px;
//   display: flex;
//   justify-content: center;
//   align-items: center;

//   & path {
//     fill: ${(props) => props.theme.color.text.light} !important;
//   }

//   @media (max-width: 992px) {
//     font-size: 0;
//   }
// `

// const CurrentLocationText = styled.div`
//   font-size: ${(props) => props.theme.font.size.s};
//   line-height: ${(props) => props.theme.font.size.s};
// `

// const CurrentLocationCursor = styled(Cursor)`
//   width: 10px;
//   height: 10px;

//   & path {
//     fill: ${(props) => props.theme.color.text.secondary};
//   }

//   @media (min-width: 992px) {
//     margin-right: 5px;
//     margin-top: 4px;
//   }

//   @media (max-width: 991px) {
//     margin-top: 2px;
//   }
// `

// const SearchOverlay = styled(motion.div)`
//   display: block;
//   position: fixed;
//   z-index: 10;
//   left: 0;
//   top: 0;
//   right: 0;
//   bottom: 0;
//   background: rgb(0, 0, 0);
// `

// const SearchFormik = styled.div`
//   position: relative;
//   z-index: 11;
// `

// const CheckNow = styled(motion.div)`
//   font-size: ${(props) => props.theme.font.size.mx};
//   font-weight: ${(props) => props.theme.font.weight.l};
// `

// export const validateForm = (values) => {
//   const errors = {}

//   if (!values.zipCode) {
//     errors.zipCode = 'Verplicht'
//   } else if (!/^[1-9][0-9]{3}[\s]?[A-Za-z]{2}$/i.test(values.zipCode)) {
//     errors.zipCode = 'Ongeldig'
//   }

//   if (!values.houseNr) {
//     errors.houseNr = 'Verplicht'
//   } else if (!/^\d+$/i.test(values.houseNr)) {
//     errors.houseNr = 'Ongeldig'
//   }

//   // eslint-disable-next-line no-useless-escape
//   if (
//     values.housNrExtention &&
//     !/^[a-zA-Z0-9\/]+$/.test(values.housNrExtention)
//   ) {
//     errors.housNrExtention = 'Ongeldig'
//   }

//   return errors
// }

// const Search = ({ fields = {}, successCallback }) => {
//   const statusStore = useSendOptionsStore()
//   const deeplinkValues = storage.get('api-postcodecheck-deeplink')

//   let dataFields = { ...fields }

//   if (Object.keys(dataFields).length === 0) {
//     dataFields = homeInfo.get().home.searching
//   }

//   const submitRef = useRef(null)

//   const [focusSearch, setFocusSearch] = useState(false)
//   const [status, setStatus] = useState('')
//   const [loaded, setLoaded] = useState(false)
//   const [initialValues, setInitialValues] = useState({
//     zipCode: '',
//     houseNr: '',
//     housNrExtention: '',
//   })

//   const getLocation = async (position) => {
//     Geocode.setApiKey('AIzaSyBl_xlo5FoGFzF8dfIxb29G-bpWVEoOB6o')
//     Geocode.setLanguage('nl')
//     Geocode.fromLatLng(
//       position.coords.latitude,
//       position.coords.longitude
//     ).then(
//       (response) => {
//         if (response && response.results) {
//           const addressComponents = response.results[0].address_components
//           const geoFields = { ...initialValues, ...{ housNrExtention: '' } }

//           addressComponents.forEach((edge) => {
//             if (edge.types.indexOf('street_number') !== -1) {
//               geoFields.houseNr = edge.long_name.replace(' ', '')
//             }

//             if (edge.types.indexOf('postal_code') !== -1) {
//               geoFields.zipCode = edge.long_name.replace(' ', '')
//             }
//           })

//           setInitialValues(geoFields)
//         }

//         setStatus('')
//       },
//       () => {
//         if (typeof window !== 'undefined') {
//           // eslint-disable-next-line no-alert
//           window.alert('Er ging iets fout')
//         }

//         setStatus('')
//       }
//     )
//   }

//   const getCurrentPosition = async () => {
//     setStatus('get-current-position')

//     navigator.geolocation.getCurrentPosition(
//       getLocation,
//       () => {
//         if (typeof window !== 'undefined') {
//           // eslint-disable-next-line no-alert
//           window.alert('U moet de GPS functionaliteit inschakkelen')
//         }

//         setStatus('')
//       },
//       {
//         enableHighAccuracy: true,
//         timeout: 5000,
//         maximumAge: 0,
//       }
//     )
//   }

//   useEffect(() => {
//     if (deeplinkValues) {
//       setInitialValues(deeplinkValues)

//       storage.remove('api-postcodecheck-deeplink')

//       setTimeout(() => {
//         submitRef.current.click()
//       }, 50)
//     }

//     setLoaded(true)
//   }, [])

//   const validate = (values) => {
//     storage.set('api-postcodecheck-request', values)

//     return validateForm(values)
//   }

//   const houseNrRef = useRef(null)
//   const housNrExtentionRef = useRef(null)
//   const initialErrors = validate(initialValues)

//   if (!loaded) {
//     return null
//   }

//   return (
//     <>
//       <SearchOverlay
//         animate={focusSearch ? 'hover' : 'rest'}
//         variants={{
//           rest: {
//             opacity: 0,
//             display: 'none',
//           },
//           hover: {
//             opacity: 0.5,
//             display: 'block',
//           },
//         }}
//         transition={{
//           duration: 0.2,
//         }}
//         onMouseEnter={() => {
//           setFocusSearch(false)
//         }}
//       />
//       <CheckNow
//         className="d-flex align-items-start mb-3 ml-4"
//         animate={{
//           y: [5, -5],
//         }}
//         transition={{
//           delay: 0.3,
//           repeat: Infinity,
//           repeatType: 'reverse',
//         }}
//       >
//         <div>{dataFields.checkText}</div>
//         <Arrow className="ml-4" />
//       </CheckNow>
//       <SearchFormik>
//         <Formik
//           enableReinitialize
//           initialValues={initialValues}
//           initialErrors={initialErrors}
//           validate={validate}
//           onSubmit={async (values, { setSubmitting }) => {
//             await setSubmitting(true)

//             const response = await API.get({
//               route: `postcodecheck?zipCode=${values.zipCode}&houseNr=${values.houseNr}&housNrExtention=${values.housNrExtention}`,
//             })

//             if (response.message === 'apis-unavailable') {
//               statusStore.setStatus(response.message)
//               return
//             }

//             storage.reset()

//             let generalStatus = ''

//             if (response.message === 'empty') {
//               generalStatus = 'zipcode-not-found'
//             } else if (response.message === 'no-results') {
//               generalStatus = 'zipcode-not-possible'
//             } else if (response.message === 'zipcode-refused') {
//               generalStatus = 'zipcode-not-possible'
//             }

//             let responseData = response.data || []

//             if (response.data && response.data.isPostcodeRefused) {
//               generalStatus = 'zipcode-not-found'
//               responseData = []
//             }

//             // responseData = responseData.filter(({ isBranch, isMainBranch }) => !(isBranch && !isMainBranch))

//             if (responseData.length === 0) {
//               generalStatus = 'zipcode-not-possible'
//             }

//             if (response.message === 'zipcode-not-possible-for-location') {
//               generalStatus = 'company-no-location'
//             }

//             if (
//               generalStatus !== '' &&
//               typeof window !== 'undefined' &&
//               typeof window.dataLayer !== 'undefined'
//             ) {
//               window.dataLayer.push({
//                 event: response.message,
//               })
//             }

//             storage.set('api-postcodecheck-request', values)
//             storage.set('api-postcodecheck-status', generalStatus)
//             storage.set('api-postcodecheck-response', responseData)

//             if (successCallback && typeof successCallback === 'function') {
//               successCallback({ data: responseData, status: generalStatus })
//             } else {
//               const staging =
//                 new URLSearchParams(window.location.search).get('env') ===
//                 'staging'

//               window.location.href = `${dataFields.button.url}${
//                 staging ? '?env=staging' : ''
//               }`
//             }
//           }}
//         >
//           {({
//             errors,
//             touched,
//             values,
//             isSubmitting,
//             setFieldValue,
//             setFieldTouched,
//           }) => {
//             const disabled = Object.keys(errors).length > 0 || isSubmitting

//             return (
//               <StyledSearch
//                 id="postcodecheck-form"
//                 className="py-4"
//                 onMouseEnter={() => {
//                   setFocusSearch(true)
//                 }}
//               >
//                 {status === 'get-current-position' && (
//                   <Loading
//                     displays={[
//                       'Huidige locatie bepalen',
//                       'Locatie omzetten naar postcode en huisnummer',
//                     ]}
//                   />
//                 )}
//                 {isSubmitting && (
//                   <Loading
//                     displays={['Postcode versturen', 'Locatie controleren']}
//                   />
//                 )}
//                 <div className="px-3 px-sm-4 px-lg-5 w-100">
//                   <div className="px-lg-3">
//                     <div className="row">
//                       <InputWrapper className="col-lg-4 pb-1 mb-1 mb-lg-0">
//                         <Label htmlFor="zipcode">Postcode</Label>
//                         <Input
//                           type="text"
//                           name="zipCode"
//                           placeholder="Postcode"
//                           id="zipcode"
//                           haserror={errors.zipCode && touched.zipCode}
//                           onChange={(event) => {
//                             const value = event.target.value
//                               .replace(/ /g, '')
//                               .toUpperCase()

//                             if (
//                               value.length === 6 &&
//                               values.zipCode.length === 5
//                             ) {
//                               houseNrRef.current.focus()
//                             }

//                             setFieldValue(event.target.name, value, true)
//                             setFieldTouched(event.target.name, true, false)
//                           }}
//                           onFocus={(event) => {
//                             event.target.select()
//                           }}
//                         />
//                         <CurrentLocation
//                           role="button"
//                           type="button"
//                           tabindex="-1"
//                           onClick={getCurrentPosition}
//                           className="d-lg-flex d-none"
//                         >
//                           <CurrentLocationCursor />
//                           {dataFields.currentLocationText}
//                         </CurrentLocation>
//                         {errors.zipCode && touched.zipCode && (
//                           <Error>{errors.zipCode}</Error>
//                         )}
//                       </InputWrapper>
//                       <div className="col-12 d-lg-none d-flex align-items-center pb-1 mb-4">
//                         <div className="d-flex align-items-center">
//                           <CurrentLocationButton
//                             role="button"
//                             type="button"
//                             tabindex="-1"
//                             onClick={getCurrentPosition}
//                           >
//                             <CurrentLocationCursor />
//                             {dataFields.currentLocationText}
//                           </CurrentLocationButton>
//                           <CurrentLocationText className="ml-2">
//                             {dataFields.currentLocationText}
//                           </CurrentLocationText>
//                         </div>
//                       </div>
//                       <InputWrapper className="col-sm-8 col-lg-2 pb-1 mb-4 mb-lg-0">
//                         <Label htmlFor="houseNr">Huisnummer</Label>
//                         <Input
//                           type="text"
//                           name="houseNr"
//                           placeholder="Huisnummer"
//                           id="houseNr"
//                           inputMode="numeric"
//                           haserror={errors.houseNr && touched.houseNr}
//                           innerRef={houseNrRef}
//                           onChange={(event) => {
//                             const { value } = event.target
//                             const lastValue = value.substr(value.length - 1)

//                             if (
//                               values.houseNr &&
//                               /^[a-zA-Z()]+$/.test(lastValue)
//                             ) {
//                               setFieldValue('housNrExtention', lastValue, true)
//                               setFieldTouched('housNrExtention', true, false)

//                               housNrExtentionRef.current.focus()
//                             } else if (/^\d+$/.test(value)) {
//                               setFieldValue(event.target.name, value, true)
//                               setFieldTouched(event.target.name, true, false)
//                             } else {
//                               setFieldValue(event.target.name, '', true)
//                             }
//                           }}
//                           onFocus={(event) => {
//                             event.target.select()
//                           }}
//                         />
//                         {errors.houseNr && touched.houseNr && (
//                           <Error>{errors.houseNr}</Error>
//                         )}
//                       </InputWrapper>
//                       <InputWrapper className="col-sm-4 col-lg-2 pb-1 mb-4 mb-lg-0">
//                         <Label htmlFor="housNrExtention">Toevoeging</Label>
//                         <Input
//                           type="text"
//                           name="housNrExtention"
//                           placeholder="Toevoeging"
//                           id="housNrExtention"
//                           haserror={
//                             errors.housNrExtention && touched.housNrExtention
//                           }
//                           innerRef={housNrExtentionRef}
//                           onFocus={(event) => {
//                             event.target.select()
//                           }}
//                         />
//                         {errors.housNrExtention && touched.housNrExtention && (
//                           <Error>{errors.housNrExtention}</Error>
//                         )}
//                       </InputWrapper>
//                       <div className="col-lg-4">
//                         <Submit
//                           ref={submitRef}
//                           type="submit"
//                           className="text-center w-100 py-2"
//                           disabled={disabled}
//                         >
//                           {dataFields.button.title}
//                         </Submit>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </StyledSearch>
//             )
//           }}
//         </Formik>
//       </SearchFormik>
//     </>
//   )
// }

// export default Search
